import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DeviceLink, UpdateLinkInput } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

export const deleteDeviceVisits = (slug: string): Promise<{ ok: boolean; deleted: number }> => {
  return axios.delete('/device-tracker/visits', { params: { slug } });
};

type UseDeleteDeviceVisitsOptions = {
  config?: MutationConfig<typeof deleteDeviceVisits>;
};

export const useDeleteDeviceVisits = ({ config = {} }: UseDeleteDeviceVisitsOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: deleteDeviceVisits,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['device-tracker'] });
      config.onSuccess?.(...args);
    },
  });
};

export const updateDeviceLink = ({ slug, ...data }: UpdateLinkInput): Promise<DeviceLink> => {
  return axios.patch(`/device-tracker/links/${slug}`, data);
};

type UseUpdateDeviceLinkOptions = {
  config?: MutationConfig<typeof updateDeviceLink>;
};

export const useUpdateDeviceLink = ({ config = {} }: UseUpdateDeviceLinkOptions = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: updateDeviceLink,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['device-tracker'] });
      config.onSuccess?.(...args);
    },
  });
};
